import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { CONTACT_INFO } from '../data/mock';
import { CheckCircle, Package, Mail, Phone, ArrowRight } from 'lucide-react';

const OrderConfirmationPage = () => {
  const orderNumber = `ST-${Date.now().toString().slice(-8)}`;

  useEffect(() => {
    document.title = 'Order Confirmed | EC Tool Works';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-[140px] pb-20">
        <div className="max-w-2xl mx-auto px-4 text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-neon-500 to-neon-600 rounded-2xl flex items-center justify-center mx-auto mb-8 shadow-glow-neon">
            <CheckCircle className="w-12 h-12 text-dark-950" />
          </div>
          
          <h1 className="font-display text-3xl md:text-4xl text-slate-900 font-extrabold uppercase tracking-tight mb-4">
            Thank You for Your Order!
          </h1>
          
          <p className="text-slate-600 text-lg mb-8">
            Your order has been placed successfully. We've sent a confirmation email with your order details.
          </p>
          
          {/* Order Number */}
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200 mb-8">
            <p className="text-slate-500 text-sm mb-2">Order Number</p>
            <p className="font-display text-2xl text-neon-400 font-bold">{orderNumber}</p>
          </div>
          
          {/* Next Steps */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 mb-8 text-left">
            <h3 className="font-display font-semibold text-slate-900 uppercase tracking-wide mb-4 flex items-center gap-2">
              <div className="w-8 h-8 bg-neon-500 rounded-lg flex items-center justify-center">
                <Package className="w-4 h-4 text-dark-950" />
              </div>
              What's Next?
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="w-7 h-7 bg-neon-500 rounded-full flex items-center justify-center text-dark-950 text-xs font-bold flex-shrink-0">1</span>
                <span className="text-slate-600">You'll receive an email confirmation shortly.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-7 h-7 bg-neon-500 rounded-full flex items-center justify-center text-dark-950 text-xs font-bold flex-shrink-0">2</span>
                <span className="text-slate-600">We'll send you tracking information once your order ships.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-7 h-7 bg-neon-500 rounded-full flex items-center justify-center text-dark-950 text-xs font-bold flex-shrink-0">3</span>
                <span className="text-slate-600">Expected delivery: 3-5 business days.</span>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200 mb-8">
            <h3 className="font-display font-semibold text-slate-900 uppercase tracking-wide mb-4">Need Help?</h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <a 
                href={`tel:${CONTACT_INFO.phone.replace(/[^0-9]/g, '')}`}
                className="flex items-center gap-2 text-neon-400 hover:text-neon-300 transition-colors font-medium"
              >
                <Phone className="w-5 h-5" />
                {CONTACT_INFO.phone}
              </a>
              <a 
                href={`mailto:${CONTACT_INFO.email}`}
                className="flex items-center gap-2 text-neon-400 hover:text-neon-300 transition-colors font-medium"
              >
                <Mail className="w-5 h-5" />
                {CONTACT_INFO.email}
              </a>
            </div>
          </div>
          
          {/* CTA */}
          <Link 
            to="/shop"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-neon-500 to-neon-600 hover:from-neon-400 hover:to-neon-500 text-dark-950 font-bold uppercase tracking-wider rounded-xl transition-all shadow-button"
          >
            Continue Shopping
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default OrderConfirmationPage;
